import { createFileRoute } from '@tanstack/react-router';
import { createLogger } from '@/utils/logger';
import { z } from 'zod';
import { ClientTaxReturnsPage } from '@/features/tax-binders/ClientTaxReturnsPage';
import { taxReturnQueryOptions } from '@/lib/query/options';
import { QueryErrorBoundary } from '@/components/query/QueryErrorBoundary';

// Search param schema for returns page
const returnsSearchSchema = z.object({
  returnId: z.string().optional(),
});

export type ReturnsSearch = z.infer<typeof returnsSearchSchema>;

const log = createLogger('ClientTaxReturnsRoute');

export const Route = createFileRoute('/tax-binders/$binderId/returns')({
  validateSearch: returnsSearchSchema,
  loader: async ({ context: { queryClient }, params: { binderId } }) => {
    // Get auth state from query cache (client auth)
    const authState = queryClient.getQueryData(['auth', 'session']) as { token?: string } | undefined;
    const token = authState?.token;

    if (token && binderId) {
      // Prefetch tax returns for this binder
      try {
        await queryClient.fetchQuery(taxReturnQueryOptions.list(binderId, token));
      } catch (error) {
        // Silently catch errors, let the component handle them
        log.debug('Tax returns prefetch failed:', error);
      }
    }
  },
  errorComponent: QueryErrorBoundary,
  component: ClientTaxReturnsPage,
});
